export class OperationCanceledException {
    public message = 'The operation has been cancelled';
}